import { render } from "./GroupOverview.vue?vue&type=template&id=4581f93a"
import script from "./GroupOverview.vue?vue&type=script&lang=js"
export * from "./GroupOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__